import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_26c5057c from 'nuxt_plugin_plugin_26c5057c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_07fce31c from 'nuxt_plugin_sentryserver_07fce31c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_bb791cd8 from 'nuxt_plugin_sentryclient_bb791cd8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_nuxtgooglemaps_7d10f27f from 'nuxt_plugin_nuxtgooglemaps_7d10f27f' // Source: ./nuxt-google-maps.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_2237eb00 from 'nuxt_plugin_cookieuniversalnuxt_2237eb00' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_cacheserver_1b22521e from 'nuxt_plugin_cacheserver_1b22521e' // Source: ./cache.server.js (mode: 'server')
import nuxt_plugin_buefy_660efaa9 from 'nuxt_plugin_buefy_660efaa9' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_axios_b7a00950 from 'nuxt_plugin_axios_b7a00950' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_image_e1920f5a from 'nuxt_plugin_image_e1920f5a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_recaptcha_c441c472 from 'nuxt_plugin_recaptcha_c441c472' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_pluginutils_2e518de3 from 'nuxt_plugin_pluginutils_2e518de3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_d3b3a324 from 'nuxt_plugin_pluginrouting_d3b3a324' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7bf103c1 from 'nuxt_plugin_pluginmain_7bf103c1' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_dynamiclocale_40ef9499 from 'nuxt_plugin_dynamiclocale_40ef9499' // Source: ../plugins/dynamic-locale.js (mode: 'all')
import nuxt_plugin_sentryerror_3ad6aa32 from 'nuxt_plugin_sentryerror_3ad6aa32' // Source: ../plugins/sentry-error.js (mode: 'client')
import nuxt_plugin_checkStorage_7f93fae4 from 'nuxt_plugin_checkStorage_7f93fae4' // Source: ../plugins/checkStorage.js (mode: 'client')
import nuxt_plugin_select_2faad3a5 from 'nuxt_plugin_select_2faad3a5' // Source: ../assets/plugins/select.js (mode: 'all')
import nuxt_plugin_directives_4ee536c6 from 'nuxt_plugin_directives_4ee536c6' // Source: ../assets/plugins/directives.js (mode: 'all')
import nuxt_plugin_vClickOutside_73fca486 from 'nuxt_plugin_vClickOutside_73fca486' // Source: ../assets/plugins/vClickOutside (mode: 'client')
import nuxt_plugin_axios_56a61cc0 from 'nuxt_plugin_axios_56a61cc0' // Source: ../assets/plugins/axios (mode: 'all')
import nuxt_plugin_vuelidate_047f43db from 'nuxt_plugin_vuelidate_047f43db' // Source: ../assets/plugins/vuelidate (mode: 'all')
import nuxt_plugin_vmask_6226895e from 'nuxt_plugin_vmask_6226895e' // Source: ../assets/plugins/v-mask.js (mode: 'client')
import nuxt_plugin_session_e8fc2692 from 'nuxt_plugin_session_e8fc2692' // Source: ../assets/plugins/session.js (mode: 'all')
import nuxt_plugin_fontloader_1af38f1c from 'nuxt_plugin_fontloader_1af38f1c' // Source: ../assets/plugins/font-loader.js (mode: 'client')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_storeinit_19f59a45 from 'nuxt_plugin_storeinit_19f59a45' // Source: ../plugins/store-init.js (mode: 'all')
import nuxt_plugin_fbsdk_f85a2450 from 'nuxt_plugin_fbsdk_f85a2450' // Source: ../assets/plugins/fb-sdk.js (mode: 'all')
import nuxt_plugin_pocketsettings_6334719a from 'nuxt_plugin_pocketsettings_6334719a' // Source: ../plugins/pocket-settings.js (mode: 'all')
import nuxt_plugin_localization_000aeaf0 from 'nuxt_plugin_localization_000aeaf0' // Source: ../plugins/localization.js (mode: 'all')
import nuxt_plugin_toastification_1bf5df90 from 'nuxt_plugin_toastification_1bf5df90' // Source: ../themes/novaporta/plugins/toastification.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_cityinit_2b7e120a from 'nuxt_plugin_cityinit_2b7e120a' // Source: ../plugins/city-init.js (mode: 'all')
import nuxt_plugin_customscriptsclient_36e36b00 from 'nuxt_plugin_customscriptsclient_36e36b00' // Source: ../plugins/custom-scripts.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"\u002Ffavicon\u002Fms-icon-144x144.png"}],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_26c5057c === 'function') {
    await nuxt_plugin_plugin_26c5057c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_07fce31c === 'function') {
    await nuxt_plugin_sentryserver_07fce31c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_bb791cd8 === 'function') {
    await nuxt_plugin_sentryclient_bb791cd8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtgooglemaps_7d10f27f === 'function') {
    await nuxt_plugin_nuxtgooglemaps_7d10f27f(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2237eb00 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2237eb00(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_cacheserver_1b22521e === 'function') {
    await nuxt_plugin_cacheserver_1b22521e(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_660efaa9 === 'function') {
    await nuxt_plugin_buefy_660efaa9(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b7a00950 === 'function') {
    await nuxt_plugin_axios_b7a00950(app.context, inject)
  }

  if (typeof nuxt_plugin_image_e1920f5a === 'function') {
    await nuxt_plugin_image_e1920f5a(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_c441c472 === 'function') {
    await nuxt_plugin_recaptcha_c441c472(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_2e518de3 === 'function') {
    await nuxt_plugin_pluginutils_2e518de3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_d3b3a324 === 'function') {
    await nuxt_plugin_pluginrouting_d3b3a324(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7bf103c1 === 'function') {
    await nuxt_plugin_pluginmain_7bf103c1(app.context, inject)
  }

  if (typeof nuxt_plugin_dynamiclocale_40ef9499 === 'function') {
    await nuxt_plugin_dynamiclocale_40ef9499(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryerror_3ad6aa32 === 'function') {
    await nuxt_plugin_sentryerror_3ad6aa32(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_checkStorage_7f93fae4 === 'function') {
    await nuxt_plugin_checkStorage_7f93fae4(app.context, inject)
  }

  if (typeof nuxt_plugin_select_2faad3a5 === 'function') {
    await nuxt_plugin_select_2faad3a5(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_4ee536c6 === 'function') {
    await nuxt_plugin_directives_4ee536c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vClickOutside_73fca486 === 'function') {
    await nuxt_plugin_vClickOutside_73fca486(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_56a61cc0 === 'function') {
    await nuxt_plugin_axios_56a61cc0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_047f43db === 'function') {
    await nuxt_plugin_vuelidate_047f43db(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmask_6226895e === 'function') {
    await nuxt_plugin_vmask_6226895e(app.context, inject)
  }

  if (typeof nuxt_plugin_session_e8fc2692 === 'function') {
    await nuxt_plugin_session_e8fc2692(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontloader_1af38f1c === 'function') {
    await nuxt_plugin_fontloader_1af38f1c(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  if (typeof nuxt_plugin_storeinit_19f59a45 === 'function') {
    await nuxt_plugin_storeinit_19f59a45(app.context, inject)
  }

  if (typeof nuxt_plugin_fbsdk_f85a2450 === 'function') {
    await nuxt_plugin_fbsdk_f85a2450(app.context, inject)
  }

  if (typeof nuxt_plugin_pocketsettings_6334719a === 'function') {
    await nuxt_plugin_pocketsettings_6334719a(app.context, inject)
  }

  if (typeof nuxt_plugin_localization_000aeaf0 === 'function') {
    await nuxt_plugin_localization_000aeaf0(app.context, inject)
  }

  if (typeof nuxt_plugin_toastification_1bf5df90 === 'function') {
    await nuxt_plugin_toastification_1bf5df90(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_cityinit_2b7e120a === 'function') {
    await nuxt_plugin_cityinit_2b7e120a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_customscriptsclient_36e36b00 === 'function') {
    await nuxt_plugin_customscriptsclient_36e36b00(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
